module.exports = __webpack_public_path__ + "img/console16.62b8f35d.jpg";